import { TableHeadCell } from "@shared/primitive-components"

export const vehicleScoreHeaderProps = {
  header: `Vehicle Score`,
  tooltipContent: `Individual Vehicle Scores are based on the vehicle's trip scores. A low vehicle score means the total trips undertaken by this vehicle were riskier than expected.`,
}

export const VehicleScoreHeader = () => <TableHeadCell {...vehicleScoreHeaderProps} />
